module.exports = __webpack_public_path__ + "static/media/trending.b4180b90.svg";